import { IconButton } from "@carbon6/c6-frontend-design";
import type { Candidate } from "../../domain/candidate";
import styles from "./CandidateRowActions.module.css";

type CandidateRowActionsProps = {
  candidate: Candidate;
  busy: boolean;
  onAccept: (candidate: Candidate) => void;
  onDismiss: (candidate: Candidate) => void;
};

/**
 * 후보 행의 두 동작.
 *
 * 메뉴에 숨기지 않는다 — 이 목록에 온 사람이 할 일이 이 둘뿐이라 한 번 더 누르게 할 이유가
 * 없다. 폐기는 되돌릴 수 없어 확인 모달을 지나고, 수락은 되돌릴 수 있어(숨김) 바로 실행한다.
 */
export function CandidateRowActions({
  busy,
  candidate,
  onAccept,
  onDismiss,
}: CandidateRowActionsProps) {
  return (
    <div className={styles.actions}>
      <IconButton
        disabled={busy}
        size="sm"
        text="수락"
        tone="primary"
        variant="surface"
        onClick={() => onAccept(candidate)}
      />
      <IconButton
        disabled={busy}
        size="sm"
        text="폐기"
        tone="neutral"
        variant="ghost"
        onClick={() => onDismiss(candidate)}
      />
    </div>
  );
}
